export const CATEGORY_STYLE = {
  'glam-glow':     { from: '#6b21a8', to: '#ec4899', icon: '✨' },
  'mens-care':     { from: '#1e3a8a', to: '#3b82f6', icon: '✂️' },
  'home-cleaning': { from: '#065f46', to: '#0891b2', icon: '🏠' },
  'pet-grooming':  { from: '#92400e', to: '#d97706', icon: '🐾' },
  'pest-control':  { from: '#14532d', to: '#4d7c0f', icon: '🛡️' },
  'plumber':       { from: '#1e3a5f', to: '#0284c7', icon: '🔧' },
  'electrician':   { from: '#713f12', to: '#b45309', icon: '⚡' },
  'carpenter':     { from: '#451a03', to: '#92400e', icon: '🪚' },
  'cc-helpers':    { from: '#1e3a8a', to: '#6366f1', icon: '🤝' },
};

export const DEFAULT_STYLE = { from: '#082189', to: '#3b82f6', icon: '🔹' };
